import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import useReviewNotes from "./useReviewNotes";
import { DueStatus, NotePreview, ReviewMember } from "./ReviewParts";

/**
 * Client review rows (dashboard card + Client reviews page): Member | Due date | Notes | Programme.
 * A row opens the member profile (click or Enter); Notes shows this coach's notepad note for the
 * member + programme (two lines; "Read more" opens the notepad when it is longer).
 */
export default function ClientReviewsTable({ rows }) {
  const navigate = useNavigate();
  const openNotes = useReviewNotes();
  const openProfile = (row) => navigate(`/member/member-profile/${row.member_id}`);

  return (
    <TableContainer>
      <Table size="small" sx={{ minWidth: 560 }}>
        <TableHead>
          <TableRow>
            <TableCell>Member</TableCell>
            <TableCell>Due date</TableCell>
            <TableCell>Notes</TableCell>
            <TableCell>Programme</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              hover
              key={`${row.member_id}-${row.program_id}`}
              tabIndex={0}
              onClick={() => openProfile(row)}
              onKeyDown={(e) => e.key === "Enter" && openProfile(row)}
              sx={{ cursor: "pointer" }}
            >
              <TableCell sx={{ maxWidth: 280 }}>
                <ReviewMember row={row} />
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                <DueStatus row={row} />
              </TableCell>
              <TableCell>
                <NotePreview text={row.note} onOpen={() => openNotes(row)} />
              </TableCell>
              <TableCell>
                <Typography variant="body2">{row.program_title}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
